/**
 *  Copyright AlpineReplay Inc, 2021. All rights reserved.
 *  Authors: Brian Bal, Slobodan Djordjevic
 */
import { connect } from "react-redux"
import React from "react"
import { withRouter } from "react-router"
import moment from "moment"

import * as act from "../actions/divisions"
import { webApi } from "../../../lib/WebApi"

import ContainerWithMenu from "./ContainerWithMenu"
import TRCInput from "../../../trace/TRCInput"
import { pageTitle, Button, trackEvent, Element, Label, Color, Row, Column } from "trux"
import androidQR from "../../../assets/img/androidQR.png"
import iosQR from "../../../assets/img/iosQR.png"
import googlePlay from "../../../assets/img/googlePlay.svg"
import appleStore from "../../../assets/img/appleStore.svg"
import "./HomePage.css"

class HomePageComponent extends ContainerWithMenu {
    constructor(props) {
        super(props, "Teams", "menu_teams")

        this.state = { billingId: "", billing: {} }

        this.onDivisionChanged = this.onDivisionChanged.bind(this)
        this.handleOnButtonClick = this.handleOnButtonClick.bind(this)
    }

    componentDidMount() {
        pageTitle(this.props.title, "Settings - Home")
        if (this.props.divisions == null || this.props.divisions.length <= 0) {
            // eslint-disable-line eqeqeq
            this.props.loadDivisions()
        }
        if (this.props.match.params.user && this.props.match.params.token) {
            this.props.fromIOS()
            var that = this
            this.props.loginByCode(
                this.props.match.params.user,
                this.props.match.params.token,
                () => {
                    that.props.loadDivisions()
                }
            )
        }
        //this.updateBilling()
        this.forwardIfNeeded(this.props.divisionId, this.props.divisions)
    }

    componentDidUpdate(prevProps) {
        /*
        if (this.props.divisions && this.props.divisions.length > 0 && prevProps.divisionId !== this.props.divisionId) {
            this.updateBilling()
        }
        */
    }

    componentWillReceiveProps(nextProps) {
        this.forwardIfNeeded(nextProps.divisionId, nextProps.divisions)
    }

    isFromIOS() {
        return this.props.via === "iosapp"
    }

    updateBilling() {
        if (this.props.divisionId !== this.state.billingId) {
            let that = this
            this.setState({ billingId: this.props.divisionId })
            act.loadDivisionBilling(this.props.divisionId).then((billing) => {
                if (billing) {
                    if (!billing.extra_price_per_game) {
                        billing.extra_price_per_game = 12500
                    }
                    console.log("HomePage billing => ", billing)
                    that.setState({ billing: billing })
                }
            })
        }
    }

    forwardIfNeeded(divisionId, divisions) {
        if (divisions.length > 0) {
            if (divisionId === "tbd") {
                let divId = divisions[0].division_id
                for (var i in divisions) {
                    var div = divisions[i]
                    for (var t in div.myTeams) {
                        var tm = div.myTeams[t]
                        if (tm.name === this.props.match.params.team) {
                            divId = div.division_id
                            break
                        }
                    }
                }
                this.props.history.replace(
                    `/${this.props.match.params.team}/settings/division/${divId}`
                )
            }
        }
    }

    isTeamInDivision(teamName, divisionId, divisions) {
        if (divisionId === "tbd" || divisions.length === 0) {
            return true
        }

        var val = false
        for (var div of divisions) {
            if (div.division_id === divisionId) {
                for (var tm of div.myTeams) {
                    if (tm.name === teamName) {
                        val = true
                        break
                    }
                }
                break
            }
        }
        return val
    }

    firstTeamInDivision(divisionId, divisions) {
        var team = null

        for (var div of divisions) {
            if (div.division_id === divisionId) {
                if (div.myTeams.length > 0) {
                    team = div.myTeams[0]
                    break
                }
            }
        }

        return team
    }

    onDivisionChanged(divId) {
        if (divId !== "tbd") {
            let firstTeam = this.firstTeamInDivision(
                parseInt(divId, 10),
                this.props.divisions
            )
            if (firstTeam) {
                console.log(`/${firstTeam.name}/settings/division/${divId}`)
                this.props.history.push(
                    `/${firstTeam.name}/settings/division/${divId}`
                )
            } else {
                alert("Whoops, That Division does not have a team")
            }
        }
    }

    hideBack() {
        return true
    }

    onBack() {
        this.onClose()
    }

    onClose() {
        console.log("onClose", this.props.via)
        if (this.props.via !== "iosapp") {
            var teamId = this.props.match.params.team
            if (teamId === "undefined") {
                for (var d in this.props.navDivisions) {
                    var div = this.props.navDivisions[d]
                    if (div.teams.length > 0) {
                        teamId = div.teams[0].name
                        break
                    }
                }
            }
            this.props.history.replace(`/${teamId}`)
        } else {
            window.location = "traceteams://return/from/admin"
        }
    }

    formatDate(str) {
        let date = moment(str)
        return date.format("MMM D, Y")
    }

    handleOnButtonClick() {
        this.props.history.push(this.props.location.pathname + "/upgrade-trace-team")
    }

    renderBilling(billing) {
        return null

        /*
        if (billing == null) { // eslint-disable-line eqeqeq
            return (
                <div className="HomePageRow billing hidden">
                    <h3>Billing</h3>
                </div>
            )
        }

        console.log('HomePage', 'billing', billing)
        
        return (
            <div className="HomePageRow billing">
                <h3>Billing</h3>
                <dl>
                    <dt>
                        <p>Elite, renews Aug 1, 2020</p>
                    </dt>
                </dl>
            </div>
        )
        */
    }

    handleOnClickReferNowButton(e) {
        if (e && e.currentTarget) {
            trackEvent({context: "Settings Page", action: "Refer Now Pressed (Family)", element: e.currentTarget})
        }
    }

    renderContent() {
        let goodDivs = this.props.divisions.filter(
            (d) => d.division_id > 0
        )
        var divOpts = goodDivs.map((div) => {
            return { title: div.title, value: div.division_id }
        })
        divOpts.splice(0, 0, { title: "---", value: "tbd" })

        var teamsLink = `/#/${this.props.match.params.team}/settings/division/${this.props.divisionId}/teams`
        var coachesLink = `/#/${this.props.match.params.team}/settings/division/${this.props.divisionId}/staff`
        let iosLink = `https://apps.apple.com/us/app/trace-teams/id1351001083`
        let androidLink = `https://play.google.com/store/apps/details?id=com.traceup.traceteams`

        return (
            <Element className="trace-container content HomePage">
                <Element className="division-picker trc-grid">
                    <Element className="col m-ff12 ml-ff6 ml-push-3 ml-after-3">
                        <TRCInput
                            type="select"
                            full
                            onChange={this.onDivisionChanged}
                            value={this.props.division.division_id}
                            options={divOpts}
                        />
                    </Element>
                </Element>

                <Element className="items">
                    <Element tag="a" href={teamsLink} className="HomePageRow teams">
                        <Label
                            type={Label.Type.Heading3}
                            color={Color.Black}
                            content="Teams"
                        />
                        <Label
                            color={Color.Black}
                            content="Set up or manage the teams that Trace games in this
                            Division."
                        />
                        <p className="admin-icon"></p>
                    </Element>

                    <Element tag="a" href={coachesLink} className="HomePageRow coaches">
                        <Label
                            type={Label.Type.Heading3}
                            color={Color.Black}
                            content="Coaches &amp; Managers"
                        />
                        <Label
                            color={Color.Black}
                            content="Invite the coaches or managers that will participate
                            in Tracing games."
                        />
                        <p className="admin-icon"></p>
                    </Element>
                </Element>
                <Element className="items">
                    <Element className="HomePageRow app">
                        <Label
                            type={Label.Type.Heading3}
                            color={Color.Black}
                            content="App"
                        />
                        <Label
                            color={Color.Black}
                            content="Download the Trace iOS or Android App - required for Tracing
                            games."
                        />
                        <Row justifyContent="center" marginTop="8">
                            <Element tag="a" href={androidLink} >
                                <Column className="app-download">
                                    <Element
                                        tag="img"
                                        className="app-download-qr"
                                        src={androidQR}
                                        alt="android QR code"
                                        hideXS hideSM
                                    />
                                    <Element
                                        tag="img"
                                        className="app-download-store"
                                        src={googlePlay}
                                        alt="google play"
                                    />
                                </Column>
                            </Element>
                            <Element tag="a" href={iosLink} >
                                <Column className="app-download">
                                    <Element
                                        tag="img"
                                        className="app-download-qr"
                                        src={iosQR}
                                        alt="android QR code"
                                        hideXS hideSM
                                    />
                                    <Element
                                        tag="img"
                                        className="app-download-store"
                                        src={appleStore}
                                        alt="google play"
                                    />
                                </Column>
                            </Element>
                        </Row>
                    </Element>
                    <Element className="HomePageRow referral">
                        <Label
                            type={Label.Type.Heading3}
                            color={Color.Black}
                            content="Refer a team, get $100"
                        />
                        <Label
                            type={Label.Type.Body}
                            color={Color.Black}
                            content="How it works:"
                            marginBottom="4"
                        />
                        <Label
                            type={Label.Type.Body}
                            color={Color.Black}
                            content="1. Tell us whom to send the referral to"
                            marginBottom="2"
                        />
                        <Label
                            type={Label.Type.Body}
                            color={Color.Black}
                            content="2. When that team signs up to Trace we will send
                                you a $100 Amazon Gift Card"
                            marginBottom="4"
                        />
                        <Button
                            trkAction="Refer Now Pressed"
                            trkLabel="Referral Button"
                            href={`https://traceup.com/refer?utm_source=go&utm_medium=webapp&utm_campaign=refs&referred_by=${
                                this.props.user ? this.props.user.email : ""
                            }`}
                            primary
                            content="Refer now"
                            onClick={e => this.handleOnClickReferNowButton(e)}
                            className="referral-button"
                        />
                    </Element>

                    {this.renderBilling(this.state.billing)}
                </Element>
            </Element>
        )
    }
}

const mapStateToProps = (state, props) => {
    let via
    let loading = false
    let loadingError = null
    let division = { division_id: "tbd", title: "" }
    let divisionId = null
    let navDivisions = []
    let divisions = []
    let title = ""
    let now = new Date()
    let user = state.user.value

    // via
    via = state.via

    // loading
    loading = !state.divisions.complete

    // loading error
    loadingError = state.divisions.error

    // division id
    divisionId = props.match.params.division_id
        ? parseInt(props.match.params.division_id, 10)
        : "tbd"

    // divisions & nav divisions
    if (state.divisions.value) {
        divisions = state.divisions.value.filter((div) => {
            return div.division_id > 0
        })
        navDivisions = divisions
    }

    // division
    if (divisions && divisions.length > 0) {
        for (let div of divisions) {
            if (div.division_id === divisionId) {
                division = div
                break
            }
        }
    }

    // title
    title = "Settings"
    if (division && window.innerWidth > 812) {
        title += ` for ${division.title}`
    }

    return {
        via,
        loading,
        loadingError,
        division,
        divisionId,
        navDivisions,
        divisions,
        title,
        now,
        user,
        rev: state.rev,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        loadDivisions: () => {
            dispatch(act.loadDivisions())
        },
        fromIOS: () => {
            if (window.sessionStorage) {
                window.sessionStorage.setItem("via", "iosapp")
            }
            dispatch({
                type: "COMMON_SET",
                key: "via",
                value: "iosapp",
            })
        },
        loginByCode: (userId, code, cb) => {
            webApi
                .loginByCode(userId, code)
                .then(() => {
                    cb(true)
                    dispatch({ type: "COMMON_RESET" })
                    dispatch({
                        type: "COMMON_SET",
                        key: "via",
                        value: "iosapp",
                    })
                })
                .catch((err) => {
                    console.warn("Admin.HomePage.loginByCode.ERROR", err)
                    cb(false)
                })
        },
    }
}

const HomePage = withRouter(
    connect(mapStateToProps, mapDispatchToProps)(HomePageComponent)
)

export default HomePage
